import { DatePicker, Select } from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Authorization from "../../../../component/Authorization";
import { DebounceSelect } from "../../../../component/DebounceSelect";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import { IoPagination } from "../../../../helper/pagination";
import { UserUI } from "../../user/entity/user.model";
import { RouteContext } from "../../user/screen/components/route.context";
import { userService } from "../../user/service/user.service";
import { PlanFilter, PlanType, PlanUI } from "../entity/plan.model";
import { planService } from "../service/plan.service";
import PlanTable from "./components/PlanTable";

function Plans() {
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const { dispatch } = useContext(SpinContext);
  const { state } = useContext(RouteContext);
  const [planPagination, setPlanPagination] = useState<IoPagination<PlanUI>>({
    totalElements: 1,
    content: [],
  });
  const [planFilter, setPlanFilter] = useState<PlanFilter>({
    page: 1,
    pageSize: 10,
  });

  let navigate = useNavigate();

  useEffect(() => {
    pageChange(planFilter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.routeId]);

  const pageChange = (planFilter: PlanFilter) => {
    dispatch({ type: spinActions.BLOCK });

    let routeId = state.routeId;

    if (routeId.length > 0) {
      planFilter.routeId = routeId;
    } else {
      planFilter.routeId = undefined;
    }

    planService
      .getPlans(planFilter)
      .then((pagination: IoPagination<PlanUI>) => {
        planPagination.current = planFilter.page;
        setPlanPagination(pagination);
        dispatch({ type: spinActions.UNBLOCK });
      })
      .catch(() => {
        dispatch({ type: spinActions.UNBLOCK });
      });
  };

  return (
    <>
      <MPageHeader crumbs={["Төлөвлөгөөнүүд"]} />

      <div className="content">
        <div className="card">
          <div className="card-header header-elements-inline">
            <h6 className="card-title">Төлөвлөгөөнүүд</h6>

            <Authorization roles={["plan-full"]}>
              <div className="header-elements">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => navigate("/plans/add")}
                >
                  <i className="icon-plus2 pr-1"></i>
                  Төлөвлөгөө нэмэх
                </button>
              </div>
            </Authorization>
          </div>
          <div className="card-body">
            <div className="d-flex bd-highlight example-parent mb-2">
              <DebounceSelect<UserUI>
                showSearch
                placeholder="Хайх"
                allowClear
                onChange={(value) =>
                  setPlanFilter({
                    ...planFilter,
                    username: value?.username,
                  })
                }
                fetchOptions={(search) => {
                  return userService.getUsers(search, state.routeId);
                }}
                style={{ maxWidth: "calc(100% - 91px)", width: "250px" }}
              />

              <Select
                placeholder="Төрөл сонгох"
                allowClear
                className="ml-2"
                onChange={(value) => {
                  setPlanFilter({
                    ...planFilter,
                    planType: value,
                  });
                }}
                style={{ width: 200 }}
              >
                <Option value={PlanType.CUSTOMER}>Харилцагч</Option>
                <Option value={PlanType.BRAND}>Брэнд</Option>
                <Option value={PlanType.PROMOTION}>Промошн</Option>
              </Select>

              <RangePicker
                className="ml-2"
                placeholder={["Эхлэх огноо", "Дуусах огноо"]}
                onChange={(dates, _dates) => {
                  setPlanFilter({
                    ...planFilter,
                    startDate: _dates[0],
                    endDate: _dates[1],
                  });
                }}
                style={{ width: 250 }}
              />

              <button
                type="button"
                className="btn btn-sm btn-primary ml-2"
                onClick={() => {
                  let _planFilter = {
                    ...planFilter,
                    page: 1,
                    pageSize: 10,
                  };

                  setPlanFilter(_planFilter);
                  pageChange(_planFilter);
                }}
              >
                <i className="icon-search4 mr-2" />
                Хайх
              </button>
            </div>

            <PlanTable
              pagination={planPagination}
              onReload={() => {}}
              onChange={(page: number, pageSize: number) => {
                let _planFilter = {
                  ...planFilter,
                  page,
                  pageSize,
                };

                setPlanFilter(_planFilter);

                pageChange(_planFilter);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Plans;
